var _title, _desc, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRestaurantBadge = function SvgRestaurantBadge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "61px",
    viewBox: "0 0 45 61",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "restaurant_Group 5 Copy")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.116397978,9.95209816 C0.116397978,15.4214904 4.54670179,19.8558936 10.0110379,19.8558936 L10.0110379,19.8558936 C15.4753741,19.8558936 19.9050883,15.4214904 19.9050883,9.95209816 L19.9050883,9.95209816 C19.9050883,4.48270588 15.4753741,0.0483027179 10.0110379,0.0483027179 L10.0110379,0.0483027179 C4.54670179,0.0483027179 0.116397978,4.48270588 0.116397978,9.95209816",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.116397978,9.95209816 C0.116397978,15.4214904 4.54670179,19.8558936 10.0110379,19.8558936 L10.0110379,19.8558936 C15.4753741,19.8558936 19.9050883,15.4214904 19.9050883,9.95209816 L19.9050883,9.95209816 C19.9050883,4.48270588 15.4753741,0.0483027179 10.0110379,0.0483027179 L10.0110379,0.0483027179 C4.54670179,0.0483027179 0.116397978,4.48270588 0.116397978,9.95209816",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.116397978,9.95209816 C0.116397978,15.4214904 4.54670179,19.8558936 10.0110379,19.8558936 L10.0110379,19.8558936 C15.4753741,19.8558936 19.9050883,15.4214904 19.9050883,9.95209816 L19.9050883,9.95209816 C19.9050883,4.48270588 15.4753741,0.0483027179 10.0110379,0.0483027179 L10.0110379,0.0483027179 C4.54670179,0.0483027179 0.116397978,4.48270588 0.116397978,9.95209816",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elenco-Piatti/Ricette/Ristoranti",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "utente_loggato_men\\xF9",
    transform: "translate(-839.000000, -2010.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(839.000000, 2010.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L45,0 L45,61 C30,51.1975519 22.5,46.2963278 22.5,46.2963278 C22.5,46.2963278 15,51.1975519 0,61 L0,0 Z",
    id: "Path-5-Copy-9",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,24 L15.5,24 C13.5673816,24 12,22.2415441 12,20.0719225 L12,14.373444 C12,14.1672325 12.1495679,14 12.3338668,14 L19,14 L19,20.0719225 C19,22.2415441 17.4331786,24 15.5,24 Z",
    id: "Stroke-24",
    stroke: "#1D1D1B",
    strokeWidth: 0.845
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,24 L22.5,24 C20.5673816,24 19,22.2415441 19,20.0719225 L19,14.373444 C19,14.1672325 19.1495679,14 19.3333067,14 L26,14 L26,20.0719225 C26,22.2415441 24.4331786,24 22.5,24 Z",
    id: "Stroke-26",
    stroke: "#1D1D1B",
    strokeWidth: 0.845
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3087089,14.7464602 C13.3876616,10.5222329 17.3854703,8 21.9994782,8 C26.6140621,8 30.6112949,10.5222329 32.6902475,14.7464602 C34.703549,18.8355895 34.3781728,23.5205978 31.835631,27.2623321 L23.0844496,39.4332213 C22.541388,40.1889262 21.4581443,40.1889262 20.9145068,39.4332213 L18.8015768,36.4942351 L18.8015768,36.4719197 L18.7848761,36.4719197 L12.175995,27.2804256 C9.62078365,23.5205978 9.2954074,18.8355895 11.3087089,14.7464602",
    id: "Fill-34",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3087089,14.7464602 C13.3876616,10.5222329 17.3854703,8 21.9994782,8 C26.6140621,8 30.6112949,10.5222329 32.6902475,14.7464602 C34.703549,18.8355895 34.3781728,23.5205978 31.835631,27.2623321 L23.0844496,39.4332213 C22.541388,40.1889262 21.4581443,40.1889262 20.9145068,39.4332213 L18.8015768,36.4942351 L18.8015768,36.4719197 L18.7848761,36.4719197 L12.175995,27.2804256 C9.62078365,23.5205978 9.2954074,18.8355895 11.3087089,14.7464602 Z",
    id: "Stroke-36",
    stroke: "#1D1D1B",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,19.9997021 C32,25.5229839 27.5223881,30 22.0002979,30 C16.4770161,30 12,25.5229839 12,19.9997021 C12,14.4770161 16.4770161,10 22.0002979,10 C27.5223881,10 32,14.4770161 32,19.9997021",
    id: "Fill-38",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    transform: "translate(12.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70087063,5.06233519 L8.5806069,5.06233519 C8.3583548,5.06233519 8.17619061,5.24466793 8.17619061,5.46771576 L8.17619061,9.3279773 L6.97944853,9.3279773 L6.97944853,5.46771576 C6.97944853,5.24466793 6.79728434,5.06233519 6.57562177,5.06233519 L6.4547685,5.06233519 C6.2325164,5.06233519 6.05035221,5.24466793 6.05035221,5.46771576 L6.05035221,9.3279773 L4.85419966,9.3279773 L4.85419966,5.46771576 C4.85419966,5.24466793 4.67203547,5.06233519 4.44919384,5.06233519 L4.3289301,5.06233519 C4.106678,5.06233519 3.92451382,5.24466793 3.92451382,5.46771576 L3.92451382,9.3279773 L3.92451382,9.55633579 L3.92451382,9.87438546 C3.92451382,10.744744 4.84417768,11.6870916 5.72080599,11.7826835 L5.72080599,24.1370546 C5.72080599,24.5076209 6.02441297,24.8115088 6.39463663,24.8115088 L6.63044788,24.8115088 C7.00067154,24.8115088 7.30368899,24.5076209 7.30368899,24.1370546 L7.30368899,11.7826835 C8.18208589,11.690632 9.10587645,10.7465143 9.10587645,9.87438546 L9.10587645,9.55633579 L9.10587645,9.3279773 L9.10587645,5.46771576 C9.10587645,5.24466793 8.92371226,5.06233519 8.70087063,5.06233519",
    id: "Fill-41",
    fill: "#00AB8E",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-46"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3019442,12.5921465 L12.3019442,24.1369366 C12.3019442,24.5075029 12.6049616,24.8113908 12.9757748,24.8113908 L13.2109966,24.8113908 C13.5818097,24.8113908 13.8848272,24.5075029 13.8848272,24.1369366 L13.8848272,12.5927366",
    id: "Fill-44",
    fill: "#00AB8E",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-49"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8374033,8.90937908 C15.8374033,11.0342341 14.6088267,12.756659 13.0937394,12.756659 C11.5774731,12.756659 10.3488965,11.0342341 10.3488965,8.90937908 C10.3488965,6.78452402 11.5774731,5.06209916 13.0937394,5.06209916 C14.6088267,5.06209916 15.8374033,6.78452402 15.8374033,8.90937908",
    id: "Fill-47",
    fill: "#00AB8E",
    mask: "url(#mask-6)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M32,19.9997021 C32,25.5229839 27.5223881,30 22.0002979,30 C16.4770161,30 12,25.5229839 12,19.9997021 C12,14.4770161 16.4770161,10 22.0002979,10 C27.5223881,10 32,14.4770161 32,19.9997021 Z",
    id: "Stroke-51",
    stroke: "#1D1D1B",
    strokeWidth: 0.7
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRestaurantBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/restaurantBadge.c6183d02.svg";
export { ForwardRef as ReactComponent };